import { Component, Output, EventEmitter } from '@angular/core';

import { DataManager } from "techlify-ng";
import { AlertService } from "techlify-ng";
import { RequestErrorService } from "techlify-ng";

import { Occupation } from "./occupation.model";

/**
 * Controller that adds a new Occupation to the system
 * 
 * @author Floyd Kissoon
 * @since 20180703
 */
@Component({
    selector: "occupation-add",
    templateUrl: "./occupation-form.html"
})
export class OccupationAddComponent
{

    @Output() onSave = new EventEmitter<Occupation>();

    private occupation = new Occupation();
    private isWorking = false;
    
    constructor(private dataManager: DataManager, private alertService: AlertService,
                private errorHandler: RequestErrorService) {}
    
    save()
    {
        this.isWorking = true;
        this.dataManager.POST("api/occupation", this.occupation).then(
            res =>
            {
                this.onSave.emit(res.occupation);
                this.alertService.addAlert(res.message, "success");
                this.isWorking = false;
            },
            error =>
            {
                this.errorHandler.handleError(error);
                this.isWorking = false;
            }
        );
    }
}